module.exports = __webpack_public_path__ + "static/media/dataex.7142d596.png";